import { render, staticRenderFns } from "./SharedChannelMoveInstanceSettings.vue?vue&type=template&id=1d52d2cc&scoped=true"
import script from "./SharedChannelMoveInstanceSettings.vue?vue&type=script&lang=js"
export * from "./SharedChannelMoveInstanceSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d52d2cc",
  null
  
)

export default component.exports